import de from "../../locales/de.json" with { type: "json" };
import en from "../../locales/en.json" with { type: "json" };
import fr from "../../locales/fr.json" with { type: "json" };
import nl from "../../locales/nl.json" with { type: "json" };

type Dictionary = Readonly<Record<string, string>>;

const DICTIONARIES: Readonly<Record<string, Dictionary>> = { de, en, fr, nl };
const ENGLISH: Dictionary = en;

/**
 * Resolve a public webshop label from the locale supplied by SculptoCMS.
 *
 * Locale resolution is deliberately a pure function: simultaneous requests or
 * independently rendered blocks cannot overwrite each other's language. A
 * regional locale first uses its base language (nl-BE -> nl), then English,
 * then the call-site fallback. Unknown keys are never rendered as an empty
 * string.
 */
export function translateStorefront(
  locale: string | null | undefined,
  key: string,
  fallback: string,
): string {
  const normalized = normalizeStorefrontLocale(locale);
  const localized = normalized ? DICTIONARIES[normalized]?.[key] : undefined;
  return localized || ENGLISH[key] || fallback || key;
}

export function normalizeStorefrontLocale(locale: string | null | undefined): string {
  if (!locale) return "";
  return locale.trim().toLowerCase().replace(/_/gu, "-").split("-")[0] ?? "";
}
